// extracted by mini-css-extract-plugin
export default {"spaced":"sitewide_spaced__rbuzO"};